import {
  PropertyFilters,
  PropertyFiltersProps,
} from "src/components/neighborhoodSearch/components/PropertyFilters";

export enum SearchSidebarTabs {
  RegionSearchResults = "regionSearchResults",
  AddressSearchResults = "addressSearchResults",
}

export const SearchSidebar = ({
  PropertyFiltersProps,
}: {
  PropertyFiltersProps: PropertyFiltersProps;
}) => {
  // AddressSearchResults is now handled directly in the main Sidebar component
  // This component only handles RegionSearchResults and default states
  return (
    <div className="w-full mt-5">
      <PropertyFilters {...PropertyFiltersProps} isSuppressExtendedFilters />
    </div>
  );
};
